export const enum Shape {
  Square = "Square",
  Arc = "Arc",
}
